import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import type { PlanDto } from '@generated/models/plan-dto';
import { environment } from '@env/environment';
import { currencySymbol } from '@shared/utils/currency';

@Component({
  selector: 'app-plan-card',
  imports: [CardModule, ButtonModule, BadgeModule, AccordionModule, TooltipModule],
  templateUrl: './plan-card.html',
  styleUrl: './plan-card.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanCard {
  @Input() plan!: PlanDto;
  @Input() isCurrent = false;
  @Input() isLoading = false;
  @Output() subscribe = new EventEmitter<PlanDto>();
  @Output() cancel = new EventEmitter<PlanDto>();

  protected readonly defaultPlanCode = environment.billing.defaultPlanCode;

  readonly unnamedPlanLabel = $localize`:@@planCard.unnamed:Unnamed Plan`;
  readonly currentBadgeLabel = $localize`:@@planCard.currentBadge:Current`;
  readonly noDescriptionLabel = $localize`:@@planCard.noDescription:No description`;
  readonly intervalMonthLabel = $localize`:@@planCard.intervalMonth:month`;

  get currencySymbol(): string {
    return currencySymbol(this.plan?.amount_currency);
  }

  get dynamicCharges() {
    return this.plan.charges?.filter(charge => charge.charge_model === 'Dynamic') || [];
  }

  get graduatedCharges() {
    return this.plan.charges?.filter(charge =>
      charge.charge_model !== 'Dynamic' &&
      charge.properties?.graduated_ranges &&
      charge.properties.graduated_ranges.length > 0
    ) || [];
  }

  onSubscribeClick(): void {
    this.subscribe.emit(this.plan);
  }

  onCancelClick(): void {
    this.cancel.emit(this.plan);
  }
}
